import type { ButtonProps } from '@mui/material/Button';
import type { Theme, SxProps } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { GQLMutation } from '@/lib/client';
import { USER_LOCK } from '@/lib/mutations/user.mutation';

type Props = ButtonProps & {
  sx?: SxProps<Theme>;
  onClose?: () => void;
};

export function PauseSessionButton({ onClose, ...other }: Props) {
  const { action: lock, loading: locking } = GQLMutation({
    mutation: USER_LOCK,
    resolver: 'sessionLock',
    toastmsg: true,
    callback: () => window.location.replace('/unlock'),
  })

  const handleLock = () => lock()

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="warning"
      onClick={handleLock}
      disabled={locking}
      {...other}
    >
      {locking ? 'Pausing...' : 'Pause Session'}
    </Button>
  );
}
